import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.25 17a.75.75 0 1 0 1.5 0V3a.75.75 0 0 0-1.5 0zM6 17.75a.75.75 0 0 1-.75-.75V9a.75.75 0 0 1 1.5 0v8a.75.75 0 0 1-.75.75M3.25 21a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75M14 17.75a.75.75 0 0 1-.75-.75v-4a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-.75.75M17.25 17a.75.75 0 1 0 1.5 0V6a.75.75 0 0 0-1.5 0z"
    }, null, -1)
  ])))
}
export default { render: render }